/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ComposeIcon = /*#__PURE__*/ createSvgIcon(
  'ComposeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5v-11c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44h5.25c.25 0 .438.078.563.234a.795.795 0 01-.005 1.031c-.128.157-.314.235-.558.235H4.5v11h11v-4.76c0-.243.078-.428.234-.553a.807.807 0 011.032 0c.156.126.234.313.234.563v4.75c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11zM8 11.254v-1.81c0-.199.035-.388.104-.569.07-.18.178-.345.326-.493l6.945-6.944c.153-.153.32-.264.5-.334S16.24 1 16.427 1c.2 0 .39.035.572.104.181.07.348.18.5.329L18.563 2.5c.152.153.263.32.333.504a1.563 1.563 0 010 1.118c-.07.184-.181.351-.334.503l-6.944 6.945a1.412 1.412 0 01-.492.326 1.56 1.56 0 01-.567.104H8.754a.735.735 0 01-.535-.215.714.714 0 01-.219-.531zm1.5-.754h1.063l4.812-4.813-.52-.541-.543-.521L9.5 9.438V10.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ComposeIcon;
